import { render } from "./NotFound.vue?vue&type=template&id=0544d30a"
const script = {}
script.render = render

export default script